import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentTypeService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/paymenttypes/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/paymenttypes')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createPaymentType(lookup: Lookup) {
        return this.httpClient.post('api/paymenttypes/create', lookup.data).toPromise();
    }

    editPaymentType(lookup: Lookup) {
        return this.httpClient.post('api/paymenttypes/edit', lookup.data).toPromise();
    }

    deletePaymentType(ids: Array<Number>) {
        return this.httpClient.post('api/paymenttypes/delete', ids).toPromise();
    }

}